module.exports = __webpack_public_path__ + "img/dormakaba-component-sm.1b043844.svg";